import PropTypes from "prop-types";
import React, { useEffect, useState, useRef } from "react";
import { withRouter } from "tools/routerCompat";
import { getCaseIssues } from "requests/homeowner/fieldReps";
import { MTable } from "components/Shared";
import MCard from "components/Shared/MCard.tsx";
import { makeHyperlink } from "components/Shared/Formatters";
import { defaultMaxHeightStyle } from "styles/sharedStyles";

function CaseIssues({ frNumber, className, cardSx = defaultMaxHeightStyle, history }) {
  const mounted = useRef(true);

  const [issues, setIssues] = useState();

  useEffect(() => {
    getCaseIssues(frNumber, mapCaseIssues, mounted);
    return () => {
      mounted.current = false;
    };
  }, []);

  const mapCaseIssues = (issues) => {
    setIssues(
      issues.map((ci) => ({
        controlIdNumber: makeHyperlink(ci.controlIdNumber, () =>
          history.push({
            pathname: "/case",
            state: {
              controlNumber: ci.controlIdNumber,
            },
          }),
        ),
        issuesComments: (
          <>
            <div className="boldText">{ci.caseIssues.map((c) => c.name).join("; ")}</div>
            <div>{ci.caseIssueComments}</div>
          </>
        ),
        policyHolder: (
          <>
            <div className="boldText">{`${ci.policyHolderFirstName} ${ci.policyHolderLastName}`}</div>
            <div>{ci.address}</div>
          </>
        ),
      })),
    );
  };

  return (
    <MCard
      title="Field Rep Case Issues"
      className={"fr-case-issues " + (className || "")}
      sx={cardSx}
      fields={[
        {
          key: "issues",
          control: (
            <MTable
              columnDefinitions={[
                { name: "Control Number", dataSource: "controlIdNumber" },
                { name: "Name/Address", dataSource: "policyHolder", style: { width: "240px" } },
                { name: "Issues/Comments", dataSource: "issuesComments" },
              ]}
              data={issues}
              emptyTableText="No case issues"
            />
          ),
        },
      ]}
    />
  );
}

CaseIssues.propTypes = {
  frNumber: PropTypes.number,
  className: PropTypes.string,
  cardSx: PropTypes.object,
  history: PropTypes.object,
};

export default withRouter(CaseIssues);
